//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiCreditCardOutline, mdiFoodAppleOutline, mdiCalendar, mdiClose,
} from '@mdi/js'
import {
  ref, computed, watch, onMounted,
} from '@vue/composition-api'
import { required, minLengthValidator, integerValidator } from '@core/utils/validation'
import { useUtils } from '@core/libs/i18n'
import { useRouter, formatCurrency, formatStdDate } from '@core/utils'
import themeConfig from '@themeConfig'
import useCryptoJs from '@core/utils/useCryptoJs'
import useLogData from '@core/utils/useLogData'
import {
  createTeam, getUserTeams, uploadTeamLogo,
} from '@api'

import AppBarUserAvatar from '@core/layouts/components/app-bar/AppBarUserAvatar.vue'
import SelectTeam from '@/views/choose-team/components/select-team/SelectTeam.vue'
import TeamName from '@/views/choose-team/components/team-name/TeamName.vue'

export default {
  name: 'ChooseTeam',
  components: {
    AppBarUserAvatar,
    SelectTeam,
    TeamName,
  },
  setup() {
    const { t } = useUtils()
    const { userData } = useCryptoJs()
    const { route, router } = useRouter()
    const { logData, updateLogData } = useLogData()

    const privateLanding = ref(null)
    const dataParams = ref(null)
    const reservationCode = ref(null)
    const matchTeamCode = ref(null)
    const selectedTeamId = ref(null)
    const type = ref(null)
    const userLogged = ref(null)

    const name = ref('')
    const imageData = ref(null)
    const myTeam = ref(null)
    const teamsOptions = ref([])

    const teamValidation = computed(() => {
      if (myTeam.value && myTeam.value !== 'UNDEFINED') return true
      if (name.value && required(name.value.trim()) === true) return true

      return false
    })

    // remove team
    const teamSelected = ref(null)

    const onLogin = async () => {
      logData.value.joinGame = 'NO'
      logData.value.reservationCode = reservationCode.value
      logData.value.redirect = 'landing'
      logData.value.field = 'all'
      logData.value.date = 'all'
      logData.value.time = 'all'

      // remove team
      logData.value.team = teamSelected.value
      await updateLogData(logData.value)

      router.push({ name: 'auth-login-phone-email' })
    }

    const onLogout = async () => {
      await localStorage.removeItem('userData')
      teamsOptions.value = []
      privateLanding.value = false
    }

    const goToRoute = () => {
      const params = { code: reservationCode.value, payType: type.value, teamId: selectedTeamId.value }
      if (teamSelected.value && teamSelected.value !== 'UNDEFINED') params.team = teamSelected.value
      router.replace({ name: 'reservation', params })
    }

    const associateTeam = async id => {
      selectedTeamId.value = id

      if (selectedTeamId.value) goToRoute()
    }

    const onCreateTeam = async () => {
      const body = {
        name: name.value.trim(),
        user_id: userData.value.user_id,
      }
      const resp = await createTeam(body)
      if (resp.ok) {
        name.value = ''
        myTeam.value = null

        if (imageData.value) {
          const formData = new FormData()
          formData.append('file', imageData.value)
          await uploadTeamLogo(formData, resp.data.team_id)
        }

        await associateTeam(resp.data.team_id)
      }
    }

    const onContinue = async () => {
      if (userLogged.value) {
        if (name.value) {
          await onCreateTeam()
        } else if (myTeam.value) {
          await associateTeam(myTeam.value)
        }
      } else {
        onLogin(true)
      }
    }

    const fetchTeams = async () => {
      try {
        const response = await getUserTeams()
        if (response.ok) teamsOptions.value = response.data
        else teamsOptions.value = []
      } catch (e) {
        console.error(e)
        teamsOptions.value = []
      }
    }

    const initChooseTeam = async () => {
      userLogged.value = await JSON.parse(localStorage.getItem('userData'))
      privateLanding.value = !!userLogged.value

      // remove team
      // const { code, team, showPay } = route.value.params
      const {
        code, team, matchCode, payType,
      } = route.value.params

      reservationCode.value = code
      teamSelected.value = `${team}`.toUpperCase()
      matchTeamCode.value = matchCode
      type.value = payType

      if (userLogged.value) await fetchTeams()
    }

    watch([myTeam], () => {
      if (myTeam.value) {
        name.value = ''
        imageData.value = null
      }
    })

    watch([name], () => {
      if (name.value) {
        myTeam.value = null
        name.value = name.value.trim()
      }
    })

    onMounted(async () => {
      await initChooseTeam()
    })

    return {
      privateLanding,
      dataParams,
      reservationCode,
      userData,
      userLogged,

      name,
      imageData,
      myTeam,
      teamsOptions,
      teamValidation,

      // methods
      formatCurrency,
      onLogin,
      onLogout,
      formatStdDate,

      onContinue,
      onCreateTeam,
      fetchTeams,
      goToRoute,

      // themeConfig
      appLogoTitle: themeConfig.app.logoTitle,

      // validations
      validators: {
        required,
        minLengthValidator,
        integerValidator,
      },

      t,

      icons: {
        mdiCreditCardOutline,
        mdiFoodAppleOutline,
        mdiCalendar,
        mdiClose,
      },
    }
  },
}
